import type { BuilderSectionData } from "../types";

/** Default max fields for newly created form builder sections. */
export const DEFAULT_SECTION_MAX_ITEMS = 50;

/** Hard ceiling for max fields per section (UI, store, and layout enforcement). */
export const MAX_SECTION_MAX_ITEMS = 50;

/**
 * Clamps a raw max-items value to the allowed section field range.
 */
export function clampSectionMaxItems(
	value: number | undefined | null,
): number | undefined {
	if (value === undefined || value === null) return undefined;
	const n = Number(value);
	if (!Number.isFinite(n) || n < 1) return undefined;
	return Math.min(Math.floor(n), MAX_SECTION_MAX_ITEMS);
}

/**
 * Returns the effective max field count for a section, or `undefined` when there is no cap.
 */
export function getSectionMaxFieldCount(
	section: BuilderSectionData,
): number | undefined {
	return clampSectionMaxItems(section.maxItems);
}

/**
 * Whether one more field can be added to a section (palette drop or move from another parent).
 */
export function sectionHasRoomForAnotherField(
	section: BuilderSectionData,
	currentChildCount: number,
): boolean {
	const max = getSectionMaxFieldCount(section);
	if (max === undefined) return true;
	return currentChildCount < max;
}
